export const container = {
  mobileSwitchWidth: 440,
  mobileSwitchHeight: 440,
  minMobileWidth: 300,
  defaultDesktopHeight: 568,
};
